import { render, staticRenderFns } from "./ArchiveInventoryWarningDialog.vue?vue&type=template&id=7ec414cc&lang=pug&"
import script from "./ArchiveInventoryWarningDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveInventoryWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports